import { configureStore } from '@reduxjs/toolkit';
import { getDefaultMiddleware } from '@reduxjs/toolkit';
import rootReducer from './slices';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

const customizedMiddleware = getDefaultMiddleware({
  serializableCheck: false
});

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['auth', 'clients', 'selectedClient'],
  stateReconciler: autoMergeLevel2
};

const pReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: pReducer,
  middleware: customizedMiddleware
});

export const persistor = persistStore(store);
export default store;
